export const ninedotsRoles = ['ninedotsAdmin', 'ninedotsTeacher']

export default role => ninedotsRoles.includes(role)
